/**
 * Rôles Symfony servis dans User.roles : ROLE_USER, plus un ROLE_<code> par habilitation du profil
 * de l'utilisateur (securite.habprofil). Le backend les recalcule à chaque requête, d'où la
 * possibilité de les modifier depuis la page « Gestion des habilitations ».
 */
export enum UserRoles {
  USER = 'ROLE_USER',

  // Habilitations homonymes des profils (hab_type ADMINISTRATION / LOCAL).
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ADMIN_FONCTIONNEL = 'ROLE_ADMIN_FONCTIONNEL',
  LECTEUR_CENTRAL = 'ROLE_LECTEUR_CENTRAL',
  ADMIN_TECHNIQUE_LOCAL = 'ROLE_ADMIN_TECHNIQUE_LOCAL',
  ADMIN_COMMUNE = 'ROLE_ADMIN_COMMUNE',
  AGENT_COMMUNE = 'ROLE_AGENT_COMMUNE',
  LECTEUR_LOCAL = 'ROLE_LECTEUR_LOCAL',

  // Fonctionnalités de la plateforme (hab_type FONCTIONNALITE).
  ACCES_ADMINISTRATION = 'ROLE_ACCES_ADMINISTRATION',
  ACCES_DASHBOARD_CENTRAL = 'ROLE_ACCES_DASHBOARD_CENTRAL',
  ACCES_DASHBOARD_COMMUNAL = 'ROLE_ACCES_DASHBOARD_COMMUNAL',
  GESTION_HABILITATIONS = 'ROLE_GESTION_HABILITATIONS',
  GESTION_PARAMETRAGE = 'ROLE_GESTION_PARAMETRAGE',
  MODERATION_CONTENU = 'ROLE_MODERATION_CONTENU',
  GESTION_SYNCHRONISATION = 'ROLE_GESTION_SYNCHRONISATION',
  /** Indicateurs : création, méthode de calcul, recalcul, activation, suppression. */
  GESTION_INDICATEURS = 'ROLE_GESTION_INDICATEURS',
  /** Volet thématique du géoportail : domaines, sous-domaines, compétences. */
  GESTION_THEMATIQUES = 'ROLE_GESTION_THEMATIQUES',

  // Comptes utilisateurs (hab_type UTILISATEUR).
  READ_UTILISATEUR = 'ROLE_READ_UTILISATEUR',
  CREATE_UTILISATEUR = 'ROLE_CREATE_UTILISATEUR',
  WRITE_UTILISATEUR = 'ROLE_WRITE_UTILISATEUR',
  DELETE_UTILISATEUR = 'ROLE_DELETE_UTILISATEUR',
}
